import type { ExternalTableSchema } from '@packages/table-builder';

/** Save parity: usePutPendingTransferAllocatesShareForDrs (PUT via Page onSave). */
export const drsRegistrationSharesDetailsBaseSchema: ExternalTableSchema = {
  metadata: {
    title: 'DRS Registration Details',
    entity: 'DrsRegistrationSharesDetails',
    description: 'Allocation line items for a pending DRS registration share.',
  },

  dataSource: {
    endpoint: '/api/award/api/app/transfer-allocate/pending-transfer-allocates-share-detail-for-drs/{transferId}',
    method: 'GET',
    rowIdField: 'transferAllocateItemId',
    confirmBeforeSave: {
      title: 'Are you sure you want to Save?',
      message: '',
      variant: 'warning',
    },
  },

  columns: [
    {
      field: 'transferAllocateItemId',
      header: 'Transfer Allocate Item Id',
      sortable: true,
      width: 340,
    },
    {
      field: 'allocatedShare',
      header: 'Allocated Share',
      sortable: true,
      width: 180,
      align: 'center',
    },
    {
      field: 'accountNumber',
      header: 'Account Number',
      sortable: true,
      width: 320,
      align: 'center',
    },
    {
      field: 'allocatedStatus',
      header: 'Allocated Status',
      type: 'badge',
      sortable: true,
      width: 240,
      align: 'center',
      badge: {
        statusMap: {
          Executed: 'success',
          Inactive: 'warning',
          Suspended: 'error',
        },
        defaultVariant: 'default',
      },
    },
  ],

  actions: {
    row: [
      {
        id: 'EDIT_INLINE_DRS_REGISTRATION_SHARES_DETAILS',
        label: 'Edit',
        actionType: 'startEditing',
      },
    ],
  },

  features: {
    search: { enabled: false },
    pagination: { mode: 'infiniteScroll', defaultSize: 50 },
    editing: { bulkSave: true },
  },
};
